var render = function () {
  var _vm$value$resume$pers, _vm$value$resume$pers2, _vm$form2, _vm$form2$company;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cert-area--wrap scroll-primary"
  }, [_c('v-sheet', {
    staticClass: "cert-area",
    attrs: {
      "color": "border"
    }
  }, [_c('v-img', {
    staticClass: "cert-area__bg cert-area__bg--ci w-100",
    attrs: {
      "src": "/images/ci.svg",
      "max-width": "700"
    }
  }), _c('v-img', {
    staticClass: "cert-area__bg cert-area__bg--bottom w-100",
    attrs: {
      "src": "/images/sub/cert/bg.png"
    }
  }), _c('div', {
    staticClass: "cert-area__inner"
  }, [_c('div', {
    staticClass: "mb-64"
  }, [_c('v-img', {
    staticClass: "cert-award mx-auto mb-38",
    attrs: {
      "src": "/images/sub/cert/award.svg",
      "max-width": "164"
    }
  }), _c('h3', {
    staticClass: "font-size-48 text-center"
  }, [_vm._v("근무 확인서")])], 1), _c('div', {
    staticClass: "mb-64"
  }, [_c('h4', {
    staticClass: "font-size-24 mb-4"
  }, [_vm._v("근무 확인 신청자")]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _c('div', {
    staticClass: "text-center"
  }, [_c('vertical-table-row', {
    attrs: {
      "term": "성명"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.resume.personalInformation.name) + " ")]), _c('vertical-table-row', {
    attrs: {
      "term": "생년월일"
    }
  }, [_vm._v(" " + _vm._s((_vm$value$resume$pers = _vm.value.resume.personalInformation.bornAt) === null || _vm$value$resume$pers === void 0 ? void 0 : (_vm$value$resume$pers2 = _vm$value$resume$pers.toDate) === null || _vm$value$resume$pers2 === void 0 ? void 0 : _vm$value$resume$pers2.call(_vm$value$resume$pers)) + " ")])], 1)], 1), _c('div', {
    staticClass: "mb-64"
  }, [_c('h4', {
    staticClass: "font-size-24 mb-4"
  }, [_vm._v("근무 이력")]), _c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "기업명",
      fn: function fn() {
        var _vm$form, _vm$form$company;
        return [_vm._v(" " + _vm._s(((_vm$form = _vm.form) === null || _vm$form === void 0 ? void 0 : (_vm$form$company = _vm$form.company) === null || _vm$form$company === void 0 ? void 0 : _vm$form$company.name) || "-") + " ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items,
    mode: _vm.mode
  }, false))], 1), _c('v-card', {
    staticClass: "mb-110",
    attrs: {
      "elevation": "0",
      "color": "grey-f7"
    }
  }, [_c('div', {
    staticClass: "pa-40 text-center"
  }, [_c('h4', {
    staticClass: "font-size-24 font-weight-medium mb-20"
  }, [_vm._v("위 사람은 마이스펙을 통해 (" + _vm._s(((_vm$form2 = _vm.form) === null || _vm$form2 === void 0 ? void 0 : (_vm$form2$company = _vm$form2.company) === null || _vm$form2$company === void 0 ? void 0 : _vm$form2$company.name) || "-") + ")에서 근무한 사실을 증명합니다.")]), _c('p', {
    staticClass: "font-size-18 grey-6--text"
  }, [_vm._v(" " + _vm._s(_vm.certifiedAt) + " ")])])]), _c('div', {
    staticClass: "bottom-logo"
  }, [_c('v-img', {
    staticClass: "bottom-logo__sign",
    attrs: {
      "src": "/images/sub/cert/sign.png",
      "max-width": "98"
    }
  }), _c('v-layout', {
    staticClass: "bottom-logo__inner",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "font-size-18 mr-48"
  }, [_vm._v("마이스펙 운영사")]), _c('v-img', {
    staticClass: "bottom-logo__logo",
    attrs: {
      "src": "/images/sub/cert/logo.jpg",
      "max-width": "276"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }